import { render, staticRenderFns } from "./BaoCaoCell.vue?vue&type=template&id=27c77510&scoped=true"
import script from "./BaoCaoCell.vue?vue&type=script&lang=ts"
export * from "./BaoCaoCell.vue?vue&type=script&lang=ts"
import style0 from "./BaoCaoCell.vue?vue&type=style&index=0&id=27c77510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c77510",
  null
  
)

export default component.exports